/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import React from 'react';
import ExpansionGrid from '../../Components/ExpansionGrid';

function PersonalDetailsReview(props) {
    const { reviewData } = props

    const apiKeysUsedForDisplayingLabel = {
        "clientNamePrefix": "Client Prefix",
        "clientFirstName": "Client First Name",
        "clientMiddleName": "Client Middle Name",
        "clientLastName": "Client Last Name",
        "gender": "Gender",
        "mobile": "Mobile",
        "mobileRelation": "Mobile Relation",
        "email": "Email",
        "emailRelation": "Email Relation",
        "maritalStatus": "Marital Status",
        "relation": "Relation",
        "relationNamePrefix": "Relation prefix",
        "relationFirstName": "Relation First Name",
        "relationMiddleName": "Relation Middle Name",
        "relationLastName": "Relation Last Name",
    }

    const getAccordianData = () => {
        return <Grid container spacing={3} css={{padding:"10px"}}>
            {reviewData && reviewData?.kycStagingPersonalDetails && Object.keys(apiKeysUsedForDisplayingLabel)?.map(apiKey=>
                <Grid container item xs={6} md={3} lg={2} alignItems={"center"} css={{border:"1px dashed lightgrey"}}>
                    <Grid item xs={12}>
                        <Typography variant="body2" css={{color:"#0098B0"}}>{apiKeysUsedForDisplayingLabel[apiKey]}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" /* color="#333333" fontWeight={"bold"} */ css={{wordBreak:"break-word"}}>{(reviewData && reviewData.kycStagingPersonalDetails[apiKey].toUpperCase()) || "--"}</Typography>
                    </Grid>
                </Grid>
            )}
        </Grid>
    }

    return (
        <ExpansionGrid title={"Personal Details"} accordianData={getAccordianData()} />
    );
}

export default PersonalDetailsReview;